import moment from "moment";
import React, { useEffect } from "react";
import { Button, Table } from "react-bootstrap";
import { BillingGroupType, InvoicePaymentType, InvoiceType, ProfitCenterType } from "./types";
import './InvoiceSearch.css';

interface IProps {
    setShowSearchResults: (showSearchResults: boolean) => void;
    invoicesFromSearch: InvoiceType[];
    currentInvoice: InvoiceType;
    setCurrentInvoice: Function;
    profitCenters: any;
    billingGroups: BillingGroupType[];
    selectInvoiceFromSearch: Function;
    invoicePaymentsFromSearch: InvoicePaymentType[];
}

const InvoiceSearch = (props: IProps) => {
    const { setShowSearchResults, invoicesFromSearch, currentInvoice, setCurrentInvoice, profitCenters, billingGroups, selectInvoiceFromSearch, invoicePaymentsFromSearch } = props;
    // let previousInvoice: InvoiceType;
    // let previousInvoicePayment: InvoicePaymentType;

    //TODO: remove when pushing to dev.
    useEffect(() => {
        //console.log("Current Invoice", currentInvoice)
    }, [currentInvoice])
    //console.log("Invoices from search", invoicesFromSearch)

    const taxTotal = invoicesFromSearch.reduce(function (acc, obj) {
        if (obj.MiscAmount !== null) {
            return acc + obj.MiscAmount;
        } else {
            return acc + 0;
        }
    }, 0);

    const amountTotal = invoicesFromSearch.reduce(function (acc, obj) {
        if (obj.InvoiceAmount !== null) {
            //console.log("InvoiceAmount : ", acc, obj.InvoiceAmount)
            return acc + obj.InvoiceAmount

        } else {
            return acc + 0
        }
    }, 0);

    const paymentsTotal = invoicePaymentsFromSearch.reduce(function (total, paymentItem) {
        return total += paymentItem?.CheckAmount;
    }, 0)

    const paymentsDate = invoicesFromSearch.reduce(function (date, invoice) {
        if (invoice.InvoiceDueDate !== invoicesFromSearch?.[0]?.InvoiceDueDate) {
            return null;
        } else {
            return invoicesFromSearch?.[0]?.InvoiceDueDate
        }
    }, invoicesFromSearch?.[0]?.InvoiceDueDate)

    const handleInvoiceClick = (invoice: InvoiceType) => {
        setCurrentInvoice(invoice);
        //console.log("New Current Invoice is", invoice);
    }

    const handleInvoicePaymentClick = (invoiceNumber: string) => {
        let clickedInvoice = invoicesFromSearch.find((invoice) => invoice.InvoiceNumber === invoiceNumber)
        setCurrentInvoice(clickedInvoice);
    }

    return (
        <>
            <h5>Invoice Search Results:</h5>
            <div className="invoice-search-result-div" >
                <Table responsive hover bordered striped className="search-result-table">
                    <thead className="sticky" >
                        <tr >
                            <th>Week Ending</th>
                            <th>Invoice</th>
                            <th>Profit Center</th>
                            <th>Invoice Number</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            invoicesFromSearch.sort(function (a, b) {
                                return new Date(a.WeekEnding).getTime() - new Date(b.WeekEnding).getTime()
                                //?? May change idx back to the InvoiceProgressId, but for now trying to avoid the errors from the duplicate keys
                            }).map((invoice: InvoiceType, idx: number) => {

                                //TODO: I believe the missing billing group and profit centers are because I don't get the inactives in my api call.  Working on this now
                                const billingGroup: BillingGroupType = billingGroups?.find((group: BillingGroupType) =>
                                    group.BillingGroupID === invoice.BillingGroupID)!;

                                const profitCenter: ProfitCenterType = profitCenters?.find((pCenter: ProfitCenterType) =>
                                    pCenter.ProfitCenterID === invoice.ProfitCenterID) || { ProfitCenterID: invoice.ProfitCenterID, ProfitCenterName: invoice.ProfitCenterID }
                                //console.log("Invoice Center", billingGroup)
                                //!! Fix for mapping cutting off the last one with this code.
                                // if(previousInvoice !== undefined && invoice.InvoiceProgressID !== previousInvoice.InvoiceProgressID || idx === 0) {
                                return (
                                    //TODO: Need to update to properly set a single invoice
                                    <tr key={idx} onClick={() => handleInvoiceClick(invoice)}
                                        className=
                                        {invoice.InvoiceProgressID === currentInvoice.InvoiceProgressID ?
                                            'selected-invoice' :
                                            ''
                                        }
                                    >
                                        <td>{moment(invoice.WeekEnding).format('MM/DD/YYYY')}</td>
                                        <td>{billingGroup.BillingGroupName ?? ""}</td>
                                        <td>{profitCenter.ProfitCenterName}</td>
                                        <td>{invoice.InvoiceNumber}</td>
                                        <td>${(invoice.InvoiceAmount)?.toLocaleString("en-US")}</td>
                                        {/* <td>{(invoice.InvoiceAmount)?.toFixed(2)}</td> */}
                                    </tr>
                                )
                            }
                                // previousInvoice = invoice;
                            )
                        }
                    </tbody>
                </Table>
            </div>
            <div className="d-flex flex-row mt-3">
                <div className="col-3">
                </div>
                <div className="col-3 mt-2">
                    <Button onClick={() => selectInvoiceFromSearch()} className="mt-2">Goto Selected Invoice</Button>
                </div>
                <div className="col-6">
                    <Table responsive hover bordered striped className="totals-table">
                        <tbody>
                            <tr>
                                <th>Misc: </th>
                                <td>${taxTotal.toLocaleString("en-US")}</td>
                                {/* <td>${taxTotal.toFixed(2)}</td> */}
                            </tr>
                            <tr>
                                <th>Total: </th>
                                <td>${amountTotal.toLocaleString("en-US")}</td>
                                {/* <td>${amountTotal.toFixed(2)}</td> */}
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
            <h5>Invoice Payments:</h5>
            <div className="invoice-search-result-div" >
                <Table responsive hover bordered striped className="search-result-table">
                    <thead>
                        <tr>
                            <th>Check Date</th>
                            <th>Check Number</th>
                            <th>Invoice Number</th>
                            <th>Check Amount</th>
                        </tr>
                    </thead>
                    {/*!!r-18-cm*/}
                    {/*@ts-ignore*/}
                    <tbody>
                        {
                            invoicePaymentsFromSearch?.sort(function (a, b) {
                                return new Date(a.CreatedDate).getTime() - new Date(b.CreatedDate).getTime()
                                //?? May change idx back to the paymentId, but for now trying to avoid the errors from the duplicate keys
                            }).map((payment: InvoicePaymentType, idx: number) => {
                                return (
                                    <tr key={idx} onClick={() => handleInvoicePaymentClick(payment.InvoiceNumber)}
                                        className=
                                        {payment.InvoiceNumber === currentInvoice.InvoiceNumber ?
                                            'selected-invoice' :
                                            ''
                                        }
                                    >
                                        <td>{moment(payment.CheckDate).format('MM/DD/YYYY')}</td>
                                        <td>{payment.CheckNumber}</td>
                                        <td>{payment.InvoiceNumber}</td>
                                        <td>${(payment.CheckAmount.toLocaleString("en-US"))}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            </div>
            <div className="d-flex flex-row mt-3">
                <div className="col-4">
                </div>
                <div className="col-2 mt-2">
                    <Button
                        onClick={showSearchResults => setShowSearchResults(!showSearchResults)}
                    >
                        Close
                    </Button>
                </div>
                <div className="col-6">
                    <Table responsive hover bordered striped className="payment-totals-table">
                        <tbody>
                            <tr>
                                <th>Total: </th>
                                <td>${paymentsTotal.toLocaleString("en-US")}</td>
                                {/* for this and the other items I've left in the to fixed way 
                                        if we want 2 decimal places, but the above adds the commas for big numbers */}
                                {/* <td>${paymentsTotal.toFixed(2)}</td>  */}
                            </tr>
                            <tr>
                                <th>Diff: </th>
                                <td>${(amountTotal - paymentsTotal).toLocaleString("en-US")}</td>
                                {/* <td>${(amountTotal - paymentsTotal).toFixed(2)}</td> */}
                            </tr>
                            <tr>
                                <th>Due Date: </th>
                                <td>
                                    {
                                        paymentsDate ?
                                            moment(paymentsDate).format('MM/DD/YYYY')
                                            : "Multiple or No Dates"
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        </>
    )
}
export default InvoiceSearch;